import React from 'react';
import Components, { Section } from '../../../bound/landingPage';
import { Union } from '../../../bound/landingPage/Wrapper';
import { ScrollRoute } from '../../../components/ScrollRoute';
import { classes } from '../../../lib';
import { SanityObject, SanitySlug } from '../../../lib/landingPage';
import Styles from './Sections.module.less';

export type SectionsProps = {
    slug: SanitySlug;
    sections: SanityObject<Section>[];
};

export const Sections = ({ sections, slug }: SectionsProps): JSX.Element => {
    return (
        <section className={classes(Styles.page, 'pb56')}>
            {sections.map((section, idx) => {
                return (
                    <ScrollRoute
                        className={Styles[section._type]}
                        key={idx}
                        path={`/${slug.current}/${section._id}`}>
                        <Union value={section} components={Components} />
                    </ScrollRoute>
                );
            })}
        </section>
    );
};
